import { createSignal } from "solid-js";
import { FieldsetViewProps } from "../model";

export function Fieldset({ title, className, children, parentClass, as_accordion }: FieldsetViewProps) {
	const [show, setShow] = createSignal(false);

	const onClick = (event) => {
		if (as_accordion) setShow(show ? false : true);
	};
	title = title || "Title Unset";
	className = className || " flex$row extend$w fit$h ";
	parentClass = parentClass || "";
	const notShowAndAcc = as_accordion && !show;
	const showAndAcc = as_accordion && show;

	return (
		<fieldset
			class={`flex$row   border!p bg!page text#pt children:(text#paget) transition-all duration-150 ease-in-out
        ${notShowAndAcc && " !h-0 !border-t-2"}
        ${(!as_accordion || showAndAcc) && " !border-2 px-2 py-1 rounded-lg shadow-xl"}
        ${parentClass}
        `}
		>
			<legend onClick={onClick} class={`px-2 font-bold text-1rem ${as_accordion && " cursor-pointer "}`}>
				{title}
			</legend>
			<div class={className}>{children}</div>
		</fieldset>
	);
}
